// Maps non-sidebar routes to the sidebar route that should stay active
const ROUTE_PARENT_MAP = {
  '/kitchenorderticket': '/billing',
  '/board/stage': '/board',
  '/workflow/designer': '/workflow',
  '/workflow/formbuilder': '/workflow',
  '/workitem/add': '/myassignments',
  '/workitem/edit': '/allassignments',
  '/workflow/formeditor': '/workflow'
};

export default ROUTE_PARENT_MAP;
